<div [class.loading]="!customer()" class="checkout-content">
  <div class="left">
    <ui-page-header subtitle="({{ items().length }} Positionen)">
      Deine Bestellung

      <ui-delivery-windows-dialog custom-action [refDate]="deliveryWindowsRefDate()"></ui-delivery-windows-dialog>
    </ui-page-header>

    @if (visibleErrors().length || unavailableProductsErrors().length) {
      <mat-card>
        <mat-card-content class="wrapper-errors-content">
          @if (visibleErrors().length) {
            <div class="wrapper-errors">
              @for (error of visibleErrors(); track error) {
                <ui-alert
                  [message]="error.message"
                  theme="info"
                  mode="light"
                  class="full-width"
                >
                </ui-alert>
              }
            </div>
          }

          @if (unavailableProductsErrors().length) {
            <ui-order-unavailable-products
              [loading]="loading()"
              (deleteUnavailableProducts)="deleteProductsFromCart($event)"
              [unavailableProductsErrors]="unavailableProductsErrors()">
            </ui-order-unavailable-products>
          }
        </mat-card-content>
      </mat-card>
    }

    @if (customer()) {
      <ui-checkout-details [customer]="customer()!" [deliveryDate]="requestedDeliveryDate()" [orderCustomReferenceText]="orderCustomReferenceText()"></ui-checkout-details>
    }

    <mat-card>
      <mat-card-content class="checkout-items">
        @for (item of items(); track item) {
          <ui-order-item [position]="$index" [product]="item.productData" [productItem]="item" [readonly]="true"></ui-order-item>
        }
      </mat-card-content>
    </mat-card>
  </div>
  @if (orderBottomBarVisible()) {
    <ui-order-bottom-bar (mainClicked)="placeOrder()" sideSheetLabel="Bestellübersicht" mainButtonLabel="Bestellung absenden" [mainButtonIsSplit]="false">
      <ng-container sideSheetContent>
        <div class="checkout-side-sheet-content">
          @let summary = calculationSummary();
          @if (summary && !summary.redacted) {
            <div class="checkout-side-sheet-content-item">
              <ui-order-overview-details [data]="summary"></ui-order-overview-details>
            </div>
          }

          <div class="checkout-side-sheet-content-item">
            <span class="side-sheet-terms-and-conditions">
              Mit Klick auf „Bestellung absenden“ akzeptiere ich die <a [link]="agbLink()" linkTarget="_blank" uiLink>AGB</a> und <a [link]="dpgLink()" linkTarget="_blank" uiLink>DPG-Bedingungen</a>
            </span>
          </div>

          @if (referenceTextEnabled()) {
            <div class="checkout-side-sheet-content-item">
              <ui-order-reference-text (textChanged)="onOrderCustomReferenceTextChanged($event)"></ui-order-reference-text>
            </div>
          }

          @if (requestedDeliveryDateEnabled()) {
            <div class="checkout-side-sheet-content-item">
              <ui-order-requested-delivery-date [refDate]="requestedDeliveryDateReference" (deliveryDateSelected)="onDeliveryDateSelected($event)"></ui-order-requested-delivery-date>
            </div>
          }

        </div>
      </ng-container>

      <ng-container sideSheetActions>
        <ui-button
          [disabled]="orderButtonDisabled()"
          [loading]="loading()"
          (clicked)="placeOrder()"
          buttonStyle="filled"
          type="button"
        >
          @if (loading() && !this.orderToken()) {
            Warenkorb wird geprüft.
          } @else if (loading() && this.orderToken()) {
            Bestellung wird abgeschickt.
          } @else {
            Bestellung absenden
          }
        </ui-button>
      </ng-container>
    </ui-order-bottom-bar>
  } @else {
    <div class="right">
      @if (calculationSummary(); as calculationSummary) {
        <ui-order-overview [minimumOrderValue]="cart()?.minimumOrderValue" [data]="calculationSummary"></ui-order-overview>
      }

      <mat-card>
        <mat-card-content class="actions">
          <ui-button
            [disabled]="orderButtonDisabled()"
            [loading]="loading()"
            (clicked)="placeOrder()"
            buttonStyle="filled"
            type="button"
          >
            @if (loading() && !this.orderToken()) {
              Warenkorb wird geprüft.
            } @else if (loading() && this.orderToken()) {
              Bestellung wird abgeschickt.
            } @else {
              Bestellung absenden
            }
          </ui-button>
          <span class="terms-and-conditions">
            Mit Klick auf „Bestellung absenden“ akzeptiere ich die <a [link]="agbLink()" linkTarget="_blank" uiLink>AGB</a> und <a [link]="dpgLink()" linkTarget="_blank" uiLink>DPG-Bedingungen</a>
          </span>
        </mat-card-content>
      </mat-card>

      @if (referenceTextEnabled()) {
        <ui-order-reference-text (textChanged)="onOrderCustomReferenceTextChanged($event)"></ui-order-reference-text>
      }

      @if (requestedDeliveryDateEnabled()) {
        <ui-order-requested-delivery-date [refDate]="requestedDeliveryDateReference" (deliveryDateSelected)="onDeliveryDateSelected($event)"></ui-order-requested-delivery-date>
      }

    </div>
  }
</div>
